import { graphqlRequest, hasGraphQLErrors, hasGraphQLNetworkError } from '~/adapters/graphqlRequest';
import { FetchSurveyWithSurveyElementsDocument, GetSurveysDocument } from '~/gql/graphql';
import { surveyElementsFrom } from '../transformers/survey_element.transformer';

const fetchSurveyElementsBySurveys = async (surveyIds: number[]) => {
  try {
    const res = await graphqlRequest<any>(GetSurveysDocument, {
      ids: surveyIds,
    });

    if (hasGraphQLNetworkError(res)) return Promise.reject(res.error);
    if (hasGraphQLErrors(res)) return Promise.reject(res.errors[0]);

    const surveys = res.data?.surveys.map((survey) => ({
      id: survey.id,
      name: survey.namesPerLanguage[0]?.surveyName,
      surveyTypeId: survey.types[0]?.id,
      surveyElements: surveyElementsFrom(survey.questions, survey.languageCodes),
    }));

    return surveys;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const fetchSurveyWithSurveyElements = async (surveyId: number) => {
  try {
    const res = await graphqlRequest<any>(FetchSurveyWithSurveyElementsDocument, { id: surveyId });

    if (hasGraphQLNetworkError(res)) return Promise.reject(res.error);
    if (hasGraphQLErrors(res)) return Promise.reject(res.errors[0]);

    const surveyLanguageCodes = res.data?.survey.namesPerLanguage.map((lang) => lang.language.langISOCode);

    return {
      id: res.data?.survey.id,
      name: res.data?.survey.namesPerLanguage[0]?.surveyName,
      surveyTypeId: res.data?.survey.types[0]?.id,
      surveyElements: surveyElementsFrom(res.data?.survey.questions, surveyLanguageCodes),
    };
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const surveyElementsQueries = {
  fetchSurveyElementsBySurveys,
  fetchSurveyWithSurveyElements,
};
